const reviewTargetSelector = '#judgeme_product_reviews';
const previewBadgeSelector = '[data-widget-name="preview_badge"], .jdgm-preview-badge';

document.addEventListener('click', (event) => {
  const trigger = event.target instanceof Element ? event.target.closest(previewBadgeSelector) : null;
  if (!trigger) return;

  const reviewTarget = document.querySelector(reviewTargetSelector);
  if (!reviewTarget) return;

  event.preventDefault();
  reviewTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
